import Cookies from "js-cookie";
import { useRef, useEffect } from "react";

// import { MINIMUM_PASSWORD_LENGTH, MAXIMUM_PASSWORD_LENGTH } from "./constants";

// const VALIDATION_ERRORS = (value) => {
//   const errors = {};

//   const requiredField = () => {
//     if (!value) {
//       errors = `This field is required`;
//     }
//   };

//   const email = () => {
//     if (!value) {
//       errors = `This field is required`;
//     }
//   };

//   const password = () => {
//     if (!value.password) {
//       errors.password = `This field is required`;
//     }

//     // password
//     if (value.password && value.password.length < MINIMUM_PASSWORD_LENGTH) {
//       errors.password = `Too short`;
//     }

//     if (
//       value.repeatPassword &&
//       value.repeatPassword.length < MINIMUM_PASSWORD_LENGTH
//     ) {
//       errors.repeatPassword = `Too short`;
//     }

//     if (value.password && value.password.length > MAXIMUM_PASSWORD_LENGTH) {
//       errors.password = `Too long`;
//     }

//     if (
//       value.repeatPassword &&
//       value.repeatPassword.length > MAXIMUM_PASSWORD_LENGTH
//     ) {
//       errors.repeatPassword = `Too long`;
//     }

//     if (!value.repeatPassword) {
//       errors.repeatPassword = `This field is required`;
//     } else if (value.repeatPassword !== value.password) {
//       errors.repeatPassword = `The passwords must match`;
//     }
//   };

//   return errors;
// };

const GENERATE_PRODUCT_NAME = (productCode) => {
  const code = productCode.toString();

  switch (code) {
    case '1001': {
      return 'E-services'
    }

    case '1002': {
      return 'E-books'
    }

    case '2001': {
      return 'Distance sale'
    }

    case '2002': {
      return 'Distance sale books'
    }

    case '3001': {
      return 'Shipping fee'
    }
  
    default:
      return '';
  }
}

const PREV_STATE = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const OUTER_CLICK = (item) => {
  document.querySelectorAll(item).forEach((item) => {
    item.addEventListener("focusout", () => {
      item.classList.remove("active");
    });
  });
};

const CURRENCY = (sum, currency) => {
  if (currency) {
    return currency + ' ' + new Intl.NumberFormat('us-US').format(sum)
  } else {
    return new Intl.NumberFormat('us-US', { style: 'currency', currency: 'EUR' }).format(sum)
  }
}

const DEBOUNCE = (func, wait, immediate) => {
  var timeout;

  return (...args) => {
    let context = this;
    let later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

const OBJECT_EMPTY = (obj) =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

const ARRAY_EMPTY = (arr) => arr.length === 0;

const SLEEP = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const CHECK_IF_REQUIRED = (value) => (value ? undefined : "Required");

const MINIMAL_INPUT_COUNT = (min) => (value) => {
  return isNaN(value) || value >= min
    ? undefined
    : `Should be greater than ${min}`;
};

const EMAIL_VALIDATION = (emailInput) => {
  //eslint-disable-next-line
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  return emailRegex.test(emailInput) ? true : false;
};

const SINGLE_PASSWORD_VALIDATION = (passInput) => {
  //eslint-disable-next-line
  const passRegex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/;
  return passRegex.test(passInput);
};

const PASSWORD_VALIDATION = (pass, repeatPass) => {
  if (typeof pass === "undefined" || typeof repeatPass === "undefined") return false;
  if (pass === "" || repeatPass === "") return false;
  
  return pass !== repeatPass ? false : true;
};

const GET_PERCENTAGE = (partialValue, totalValue) => {
  return (100 * partialValue) / totalValue;
};

const EXPECTED_COOKIES = {
  userLoggedIn: {
    name: "userLoggedIn",
  },
  userJwt: {
    name: "userjwt",
  },
  userName: {
    name: "userName",
  },
  userLevel: {
    name: "userLevel",
  },
};

const GET_TOKEN = () => Cookies.get(EXPECTED_COOKIES.userJwt.name);
const GET_USER_NAME = () => Cookies.get(EXPECTED_COOKIES.userName.name);
const GET_USER_LEVEL = () => Cookies.get(EXPECTED_COOKIES.userLevel.name);

const GET_HEADERS = {
  method: "GET",
  headers: new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + GET_TOKEN(),
  }),
};

export {
  // VALIDATION_ERRORS,
  GENERATE_PRODUCT_NAME,
  DEBOUNCE,
  SLEEP,
  CHECK_IF_REQUIRED,
  MINIMAL_INPUT_COUNT,
  EMAIL_VALIDATION,
  SINGLE_PASSWORD_VALIDATION,
  PASSWORD_VALIDATION,
  GET_TOKEN,
  GET_PERCENTAGE,
  GET_USER_NAME,
  GET_USER_LEVEL,
  OBJECT_EMPTY,
  ARRAY_EMPTY,
  EXPECTED_COOKIES,
  GET_HEADERS,
  OUTER_CLICK,
  PREV_STATE,
  CURRENCY,
};
